<template>
  <div
    class="bg-white overflow-hidden border-t border-t-gray-200 z-40 fixed bottom-0 left-0 w-full h-11 shadow-xs sm:hidden flex items-center justify-between"
  >
    <div
      class="flex items-center justify-center w-full grow relative"
      :class="[
        route.path === localePath(i.path)
          ? 'text-primary-blue '
          : 'text-gray-400',
      ]"
      @click="changePage(i)"
      v-for="i in footerItems"
      :key="i.id"
    >
      <Icon
        :name="i.icon"
        size="25"
        v-if="i.icon"
        :color="
          i.id === 3
            ? '#ffffff'
            : route.path === localePath(i.path)
              ? '#0047ab'
              : '#0f172a'
        "
      />
    </div>
    <div class="w-full flex items-center justify-center grow">
      <div
        class="h-6 size-6 rounded-full bg-gray-100 animate-pulse"
        v-if="loading"
      ></div>
      <div class="" v-else>
        <NuxtLink :to="$localePath('/dashboard')" v-if="user">
          <BaseImage
            @contextmenu.prevent
            @dragstart.prevent
            :uri="userAvatar"
            :alt="
              `${user.name || ''} ${user.last_name || ''}` || 'Medium.am user'
            "
            img-class="h-6 size-6 rounded-full object-cover border-gray-100"
          />
        </NuxtLink>
        <NuxtLink
          :class="
            route.path === localePath('/auth/login') ||
            route.path === localePath('/auth/register')
              ? 'text-primary-blue '
              : 'text-gray-400'
          "
          class="flex items-center justify-center h-6 size-6 rounded-full"
          role="button"
          :to="$localePath('/dashboard')"
          v-else
          type="button"
        >
          <Icon
            name="tabler:user-filled"
            :color="
              route.path === localePath('/auth/login') ||
              route.path === localePath('/auth/register')
                ? '#0047ab'
                : '#0f172a'
            "
            size="25"
          />
        </NuxtLink>
      </div>
    </div>
    <button
      name="Toggle drawer"
      title="Toggle drawer"
      class="flex items-center justify-center w-full grow text-gray-400"
    >
      <Icon
        name="tabler:x"
        size="25"
        weight="light"
        class="text-primary"
        @click="appStore.closeDrawer"
        v-if="appStore.showDrawer"
      />

      <Icon
        @click="appStore.openDrawer"
        v-else
        name="tabler:menu-2-filled"
        size="25"
      />
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, shallowRef, type Component } from "vue";
import { useRoute } from "vue-router";
import { useWindowSize } from "@vueuse/core";
import type { AppUser } from "~~/types/user";

const newArtStore = useNewArtworkStore();
const { width } = useWindowSize();
const localePath = useLocalePath();

export interface FooterItem {
  id: number;
  path: string;
  title?: string;
  icon: string | null;
  class?: string;
}

const footerItems = shallowRef<FooterItem[]>([
  {
    id: 1,
    path: "/gallery",
    title: "Gallery",
    icon: "tabler:home-filled",
    class: "gallery",
  },

  {
    id: 2,
    path: "/dashboard/favorites",
    title: "Favorites",
    icon: "tabler:heart-filled",
    class: "favorites",
  },

  {
    id: 3,
    path: "/",
    title: "New artwork",
    icon: "tabler:square-rounded-plus-filled",
    class: "newArtwork",
  },
]);

const route = useRoute();
const appStore = useAppStore();
const user = useState<AppUser | null>("auth-user", () => null);
const loading = useState<boolean>("auth-loading");
const footerTour = ref();
const isMobile = computed<boolean>(() => width.value < 640);
const userAvatar = computed<string>(
  () => user.value?.avatar || "/no_avatar.jpg",
);
const test = ref<boolean>(true);

const changePage = async (p: FooterItem) => {
  if (p.id === 3) {
    newArtStore.openNewArtwork();
    return;
  }
  if (p && p.path) {
    await navigateTo(localePath(p.path));
  }
};

onMounted(() => {
  setTimeout(() => {
    if (test.value) return;
    if (!isMobile.value) return;
    footerTour.value?.startTour();
  }, 500);
});
</script>

<style>
[id$="-tooltip"] {
  background-color: #fff !important;
  color: #000 !important;
  padding: 10px !important;
  border-radius: 12px !important;
  font-size: 14px !important;
  z-index: 9999;
  max-width: 300px;
  position: absolute;
  pointer-events: auto;
}
#vjt-backdrop {
  background-color: #5c595980;
}
.vjt-actions button {
  background: #0047ab !important;
  color: #fff !important;
  border-radius: 6px !important;
}
[class*="vjt-highlight-"] {
  outline: 2px solid #0047ab !important;
}
.vjt-sr-only {
  clip-path: none !important;
}
</style>
